


















































import { ValidationProvider } from "vee-validate";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
// @ts-ignore
import ClickOutside from "vue-click-outside";
import Multiselect from "vue-multiselect";

@Component({
    directives: {
        ClickOutside
    },
    components: {
        ValidationProvider,
        Multiselect
    }
})
export default class ElSelect extends Vue {
    @Prop({ default: "" }) readonly name!: string;

    @Prop({ default: "" }) readonly value!: string;

    @Prop({ default: "" }) placeholder!: string;

    @Prop({ default: "" }) inputClass!: string;

    @Prop({ default: "" }) readonly label!: string;

    @Prop({ default: "" }) readonly rules!: string;

    @Prop({ default: "dark" }) readonly theme!: string;

    @Prop({ default: false }) readonly grouped!: boolean;

    @Prop({ default: "sale" }) sale_or_let!: string;

    @Prop({ default: false }) multiple!: boolean;

    @Prop({ default: 5 }) limit!: number;

    @Prop({ default: false }) typeahead!: boolean;

    @Prop({ default: false }) selectMinWidth!: string | false;

    @Prop({ required: true }) options!: SelectOption[];

    searchedOptions: SelectOption[] = [];

    localvalue: number[] | "" = [];

    isLoading: boolean = false;

    get labelText() {
        if (this.label.length > 0) {
            return this.label;
        }

        if (this.$te(`forms.labels.${this.name}`)) {
            return this.$t(`forms.labels.${this.name}`);
        }

        return false;
    }

    get placeholderText() {
        if (this.placeholder.length > 0) {
            return this.placeholder;
        }

        if (this.$te(`forms.placeholders.${this.name}`)) {
            return this.$t(`forms.placeholders.${this.name}`);
        }

        return false;
    }

    get selectWidth() {
        if (this.selectMinWidth) {
            return this.selectMinWidth;
        }
        return { "min-w-[150px]": !this.multiple, "min-w-[240px]": this.multiple };
    }

    customLabel(props: any) {
        return props.label;
    }

    @Emit("input")
    handleInput(e:any, s:any) {

        // localvalue is an array and we are selecting multiple
        if (this.multiple && Array.isArray(this.localvalue)) {
            this.localvalue.forEach((childOption: any) => {
                if (childOption.hasOwnProperty("parent_id") && childOption.parent_id !== null) {
                    let matchedParent = this.options.find((option: SelectOption) => `${option.value}` === `${childOption.parent_id}`);

                    // @ts-ignore
                    if (matchedParent && matchedParent.hasOwnProperty("value") && !this.localvalue.map((option: any) => option.value).includes(matchedParent.value)) {
                        // @ts-ignore
                        this.localvalue.push(matchedParent);
                    }
                }
            });

            // @ts-ignore
            return this.localvalue.map((option: any) => option.value).join(",");
        } else {
            // @ts-ignore
            return this.localvalue ? this.localvalue.value : "";
        }
    }

    @Watch("value", { immediate: true })
    handleValueChanged(newValue: string) {
        const values = `${newValue}`.split(",");
        if (this.multiple) {
            // Flatten the options
            let flatOptions = this.options.reduce((acc: any, option: any) => {
                if (option.children) {
                    return [...acc, option, ...option.children];
                }
                return [...acc, option];
            }, []);

            // flatOptions unique on value, label combination
            flatOptions = flatOptions.filter((v: any, i: any, a: any) => a.findIndex((t: any) => t.value === v.value && t.tagLabel === v.tagLabel) === i);

            //@ts-ignore
            this.localvalue = flatOptions.filter(o => values.includes(`${o.value}`));
        } else {
            //@ts-ignore
            this.localvalue = this.options.filter(o => `${values[0]}` === `${o.value}`);
        }
    }

    asyncFind(query: string) {
        this.isLoading = true;

        this.searchedOptions = this.options.filter((option: SelectOption) => {
            return option.label?.toLowerCase().includes(query.toLowerCase()) || option.children?.some((child: SelectOption) => child.label?.toLowerCase().includes(query.toLowerCase()));
        });

        this.isLoading = false;
    }

    @Watch("options", { immediate: true })
    handleOptionsChanged() {
        this.searchedOptions = this.options;
    }
}
